import AidexacxDocumentAPI from 'dashboard/api/aidexacx/document';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AidexacxDocument',
  API: AidexacxDocumentAPI,
  actions: mutationTypes => ({
    retry: async ({ commit }, id) => {
      const response = await AidexacxDocumentAPI.retry(id);
      commit(mutationTypes.UPSERT, response.data);
      return response;
    },
  }),
});
